import { IsNotEmpty, IsArray, IsOptional } from "class-validator";

import { IAdapterBacklogRuleAction } from "./adapter-backlog-rule-action.interface";

export class AdapterBacklogRuleActionDto implements IAdapterBacklogRuleAction {
  // Other ERP specific attributes
  [s: string]: any;

  @IsOptional()
  @IsArray()
  entity_ids?: string[];

  @IsNotEmpty()
  rule_id: string;

  @IsOptional()
  action_id?: string;

  // query?
}
